// =============================================
// AutoGenerateMapsPage — /mapy-tematyczne/auto-generate
// =============================================
// STOP-F. Wrapper page dla BulkAutoGeneratePanel + BulkAutoGenerateProgress.
// Provider zawijajaca state mount w App.tsx (cross-nav persistence — KOREKTA 6.4).
// =============================================

import { BulkAutoGeneratePanel } from "@/components/thematic-maps/BulkAutoGeneratePanel";
import { BulkAutoGenerateProgress } from "@/components/thematic-maps/BulkAutoGenerateProgress";

export default function AutoGenerateMapsPage() {
  return (
    <div className="container mx-auto py-6 max-w-6xl">
      <BulkAutoGeneratePanel />
      <BulkAutoGenerateProgress />
    </div>
  );
}
